import { useQuery } from '@tanstack/react-query'
import axios from 'axios'
import TransitApiConfig from '../../../TransitOperationEditor/hooks/apiConfig'
import { UserPreferenceUpdateRequest } from '../../../../../api/models/user-preference-update-request'
import { UserPreferenceResponse } from '../../../../../api/models/user-preference-response'

const {
  baseUrl,
  queryKeys: {
    getUserPreferences,
  },
} = TransitApiConfig.paths.userPreferences

export async function updateUserPreferences(data: UserPreferenceUpdateRequest[]) {
  return (await axios.patch<UserPreferenceResponse[]>(`${baseUrl}`, data)).data
}

function useUserPreferenceApi() {
  const fetchUserPreferences = useQuery({
    queryFn: async ({ signal }) => (await axios
      .get<UserPreferenceResponse[] | undefined>(`${baseUrl}`, { signal })).data,
    queryKey: getUserPreferences(),
    staleTime: Infinity, // never stale
    retry: false,
  })

  return {
    fetchUserPreferences,
  }
}

export default useUserPreferenceApi
